"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiTimelineConnector = function MuiTimelineConnector(theme) {
  return {
    root: {
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    }
  };
};

var _default = MuiTimelineConnector;
exports["default"] = _default;